module.exports = __webpack_public_path__ + "static/media/th-start__diamond.cab2cc7f.svg";